// How each sender's notifications are shown, registered where the client is
// composed.

import { registerNotificationPresenters } from "@/notifications/client";
import { calendarNotifications } from "@/planning/client";
import { feedNotifications } from "@/feeds/client";
import { marketNotifications } from "@/finance/client";
import { backupNotifications } from "@/backup/client";

registerNotificationPresenters([
  calendarNotifications,
  marketNotifications,
  feedNotifications,
  backupNotifications,
]);
